import { useUser } from "../../../../misc/Permission";
import { useReadyCheck } from "../../../../misc/pdf/UseReadyCheck";
import { forwardRef } from "react";
import { PDF } from "../../../../misc/pdf/parts/PDF";
import { ClientInfoContextProvider, PDFProjectContext } from "../openings/OpeningsPDF";
import { ImperialDistance } from "../../../../misc/ImperialDistance";
import { MetricDistance } from "../../../../misc/MetricDistance";
import { kdFrameConstruction, weldFrameConstruction } from "../../quote/openings/Const";
import { blankDrawingInfo } from "../openings/MakeSubmittal";
import { ImageTilePage } from "../openings/ImageTilePage";
import { PdfTableServerRendered } from "../openings/pdf/PdfTableServerRendered";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const OpeningSizePDF = /*#__PURE__*/ forwardRef(function OpeningSizePDF(props, ref) { const usr = useUser(); const ready = useReadyCheck(props.onReady); ready.require(!!usr); const parser = props.sys === "imperial" ? input => ImperialDistance.parse(input) : input => MetricDistance.parse(input); const tableData = { header: [...props.columns.map(c => c.display), "Rough Opening Width", "Rough Opening Height"], content: props.data.map((i, index) => { let width = ""; let height = ""; if (i.screenElevation && i.screenElevationOutsideWidth && i.screenElevationOutsideHeight) {
        if (i.openingType === "Single" || i.openingType === "Pair") {
            if (i.frameConstruction === weldFrameConstruction) {
                width = parser(i.screenElevationOutsideWidth).add(ImperialDistance.parse("1/4\"")).toString();
                height = parser(i.screenElevationOutsideHeight).add(ImperialDistance.parse("1/8\"")).toString();
            }
            else if (i.frameConstruction === kdFrameConstruction) {
                width = parser(i.screenElevationOutsideWidth).add(ImperialDistance.parse("-2\"")).toString();
                height = parser(i.screenElevationOutsideHeight).add(ImperialDistance.parse("-1\"")).toString();
            }
        }
        else if (i.openingType === "Window") {
            if (i.frameConstruction === weldFrameConstruction) {
                width = parser(i.screenElevationOutsideWidth).add(ImperialDistance.parse("1/4\"")).toString();
                height = parser(i.screenElevationOutsideHeight).add(ImperialDistance.parse("1/4\"")).toString();
            }
            else if (i.frameConstruction === kdFrameConstruction) {
                width = parser(i.screenElevationOutsideWidth).add(ImperialDistance.parse("-1 1/4\"")).toString();
                height = parser(i.screenElevationOutsideHeight).add(ImperialDistance.parse("-2\"")).toString();
            }
        }
    }
    else {
        const widthRaw = i.inactiveDoorWidth !== "" ? parser(i.nominalWidth).add(parser(i.inactiveDoorWidth)) : parser(i.nominalWidth);
        let dWidth = widthRaw.add(ImperialDistance.parse("4\""));
        let dHeight = parser(i.nominalHeight).add(ImperialDistance.parse("2\""));
        if (i.frameConstruction === kdFrameConstruction) {
            dWidth = dWidth.add(ImperialDistance.parse("-2\""));
            dHeight = dHeight.add(ImperialDistance.parse("-1\""));
        }
        else if (i.frameConstruction === weldFrameConstruction) {
            dWidth = dWidth.add(ImperialDistance.parse("1/4\""));
            dHeight = dHeight.add(ImperialDistance.parse("1/8\""));
        }
        else {
            dWidth = parser("0");
            dHeight = parser("0");
            console.error("missing frame profile");
        }
        width = dWidth.toString();
        height = dHeight.toString();
    } return [...props.columns.map((c, index) => c.render ? c.render(i, blankDrawingInfo) : i[c.key]), width, height]; }) }; return /*#__PURE__*/ _jsx("div", { ref: ref, children: /*#__PURE__*/ _jsx(PDF, { children: /*#__PURE__*/ _jsx(PDFProjectContext.Provider, { value: props.project, children: /*#__PURE__*/ _jsxs(ClientInfoContextProvider, { client: props.client, clientContact: props.clientContact, children: [/*#__PURE__*/ _jsx(PdfTableServerRendered, { value: tableData }), props.wallTypeImages && /*#__PURE__*/ _jsx(ImageTilePage, { title: "Wall Types", images: props.wallTypeImages }), props.anchorImages && /*#__PURE__*/ _jsx(ImageTilePage, { title: "Anchors", images: props.anchorImages })] }) }) }) }); });
